import { AntdTablePagination } from "./Table.d";

export const getDefaultDisplayingHelpText = (pagination: AntdTablePagination) => `of ${pagination.total} items`;

export const getDefaultMobileHelpText = (pagination: AntdTablePagination) =>
  `${pagination.pageSize}/${pagination.total} items`;
